// Tema claro/escuro. A preferência vive em localStorage("theme"):
// "light" | "dark" | "system". O tema efetivo é aplicado como
// data-theme="light|dark" no <html> — o index.css resolve o resto.
// O index.html tem um script inline que aplica antes do primeiro paint
// (anti-flash); este módulo cuida do runtime (troca + acompanhar o SO).

export type ThemePref = "light" | "dark" | "system";

const KEY = "theme";
const media = window.matchMedia("(prefers-color-scheme: dark)");

export function getThemePref(): ThemePref {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" || v === "system" ? v : "system";
}

function resolve(pref: ThemePref): "light" | "dark" {
  return pref === "system" ? (media.matches ? "dark" : "light") : pref;
}

function apply(pref: ThemePref) {
  document.documentElement.dataset.theme = resolve(pref);
}

export function setThemePref(pref: ThemePref) {
  localStorage.setItem(KEY, pref);
  apply(pref);
}

/** Chamar uma vez no boot: aplica e acompanha mudanças do SO em modo system. */
export function initTheme() {
  apply(getThemePref());
  media.addEventListener("change", () => {
    if (getThemePref() === "system") apply("system");
  });
}
